import React from 'react';
import './Contact.css';

function Contact() {
  return (
    <section id="contact">
      <p className="section__text__p1 outfit-semibold">Get in Touch</p>
      <h1 className="title playfair-display-bold">Contact Me</h1>
      <div className="contact-info-upper-container">
        <div className="contact-info-container">
          <img src="./assets/email.png" alt="Email icon" className="icon contact-icon email-icon" />
          <p className="outfit-medium">
            <a href="mailto:prakash18052006@gmail.com">prakash18052006@gmail.com</a>
          </p>
        </div>
        <div className="contact-info-container">
          <img src="./assets/linkedin.png" alt="LinkedIn icon" className="icon contact-icon" />
          <p className="outfit-medium">
            <a href="https://www.linkedin.com/in/codepc/">LinkedIn</a>
          </p>
        </div>
      </div>
    </section>
  );
}

export default Contact;
